import { defineMessages } from 'react-intl';
import { sharedActionMessages } from './shared-action.messages';

const protocolDetailModalMessagesBase = defineMessages({
  dialogTitle: {
    defaultMessage:
      '{mode, select, create {/ New Protocol} view {/ {label}} edit {/ {label}} other {/ {label}}}',
    id: 'FtN7QDHMme',
    description:
      'Modal heading for viewing, editing, or creating a protocol; leading slash matches app visual style',
  },
  protocolNameFallback: {
    defaultMessage: 'Protocol',
    id: 'aWq8QlT9bE',
    description:
      'Fallback heading when a protocol has no display name in the detail modal',
  },
  modalDescription: {
    defaultMessage:
      '{mode, select, view {View your protocol} edit {Edit your protocol} create {Create your protocol} other {View your protocol}}',
    id: 'xVz42gMSsI',
    description: 'Subtitle in the protocol detail modal for view vs edit vs create',
  },
  protocolInstructions: {
    defaultMessage: 'Protocol instructions',
    id: 'Jxx3C+0uDY',
    description: 'Label for the protocol instructions in the detail modal',
  },
  namePlaceholder: {
    defaultMessage: 'e.g. Drug interactions',
    id: 'N3/hFd82hR',
    description: 'Placeholder example for the custom protocol name field',
  },
  instructionsPlaceholder: {
    defaultMessage:
      'e.g. Check literature for common drug interactions with the patient’s current medications',
    id: 'H5m1GS1P06',
    description: 'Placeholder example for the protocol instructions textarea',
  },
  customise: {
    defaultMessage: 'Customize',
    id: '5cr0x2OiDo',
    description:
      'Secondary action to copy a library protocol into an editable custom version',
  },
  delete: {
    defaultMessage: 'Delete',
    id: 'fXLIeVGBcJ',
    description: 'Destructive action to remove the custom protocol',
  },
});

/** Merged after `defineMessages` so @formatjs/cli can statically parse literals only. */
export const protocolDetailModalMessages = {
  ...protocolDetailModalMessagesBase,
  protocolName: sharedActionMessages.protocolName,
  save: sharedActionMessages.save,
  cancel: sharedActionMessages.cancel,
};
